import { useState as c, useEffect as i } from "react";
function m() {
  const [o, u] = c(!1);
  return i(() => {
    if (typeof document > "u")
      return;
    const t = document.documentElement, e = () => {
      u(t.getAttribute("dir") === "rtl");
    };
    e();
    const n = new MutationObserver((s) => {
      for (const r of s)
        r.type === "attributes" && r.attributeName === "dir" && e();
    });
    return n.observe(t, { attributes: !0 }), () => {
      n.disconnect();
    };
  }, []), o;
}
export {
  m as useIsDocumentRTL
};
